// extracted by mini-css-extract-plugin
export default {"fragment":"uL5h_SJG"};